import type { SVGProps } from 'react';

/**
 * Red propeller plane in the style of the Aviator game logo, climbing to the right.
 * Draws in `currentColor`; the propeller blade spins (a fast squash, read as motion blur).
 */
const AviatorIcon = ({ className = '', ...props }: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} {...props}>
    <g transform="rotate(-12 12 12)">
      {/* Fuselage, tail fin, lower and upper wing */}
      <path d="M3 11.2c0-.7.6-1.2 1.3-1.2H16c1.9 0 3.5 1 3.9 2-.4 1-2 2-3.9 2H6.5L3.6 12.6c-.4-.3-.6-.8-.6-1.4z" />
      <path d="M3.4 10.6 2.5 6.4c-.1-.5.5-.8.9-.5l3.6 4.1z" />
      <path d="M9.5 12.6h4.2l-2.7 5.1c-.2.4-.6.6-1 .6H8.7c-.5 0-.8-.5-.6-.9z" />
      <path d="M10.4 11.4h3.6l1.6-3.4c.2-.4-.1-.8-.5-.8h-1.2c-.4 0-.7.2-.9.5z" fillOpacity={0.85} />
      {/* Cockpit window */}
      <path
        d="M14.6 10.3h1.4c.9 0 1.7.4 2.2 1h-3.6z"
        className="fill-body-inverse"
        fillOpacity={0.55}
      />
      {/* Propeller hub and spinning blade */}
      <circle cx="20.2" cy="12" r=".9" />
      <rect
        data-propeller
        x="19.85"
        y="7.2"
        width="1"
        height="9.6"
        rx=".5"
        className="animate-propeller motion-reduce:animate-none"
        style={{ transformBox: 'fill-box', transformOrigin: 'center' }}
      />
    </g>
  </svg>
);

export default AviatorIcon;
